import Button, { ButtonProps } from '@mui/material/Button';
import clsx from 'clsx';

import { ReactComponent as WarningIcon } from 'assets/images/warning.svg';

import styles from './styles.module.scss';

type StyledButtonProps = {
  active?: boolean;
  warning?: boolean;
} & ButtonProps;

export default function TabsButton({
  active,
  warning,
  disabled,
  ...props
}: StyledButtonProps) {
  return (
    <Button
      {...props}
      endIcon={warning ? <WarningIcon /> : undefined}
      classes={{
        root: clsx(
          styles.root,
          active && styles.active,
          warning && styles.warning,
          disabled && styles.disabled
        ),
        endIcon: styles.endIcon,
      }}
    />
  );
}
